import toast from "./toast.json";

export default {
  toast,
};
